import System from '@/store'

// 埋点通用数据 -默认值 
// 会基于默认值使用shuaTiburyPoints函数进行修改，然后在外部直接调埋点方法
export let buryPoints = {
  fakaoQuestionType: '',      //刷题题型
  primaryCatagory: '',  //一级分类
  firstDirectory: '',   //一级目录
  secondaryCatagory: '', //二级分类
  secondaryDirectory: '', //二级目录
  practiseFunction: '',  //刷题功能区
  numberCompletedQuestions: '',  //已完成题目数
  masteryDegree: '',  //掌握程度
  totalNumber: ''     //题集总数量
}

//获取埋点数据
export const shuaTiburyPoints = (obj) => {
  buryPoints = { ...obj }
}

export const getBuryPoints = () => {
  let flag = ['/obt','/obt/analysis', '/w/answerAnalysis', '/w/dataReport', '/w/exerciseFashuo', '/w/sujiQuestion', '/w/reciteBrushQuestions','/w/answerAnalysis', '/w/mokao/intelligentTopic'].some(item => window.location.href.indexOf(item) !== -1)
  console.log(flag) //在这两个页面 返回true
  if (flag) {
    return buryPoints
  }
  return {
    fakaoQuestionType: undefined,      //刷题题型
    primaryCatagory: undefined,  //一级分类
    firstDirectory: undefined,   //一级目录
    secondaryCatagory: undefined, //二级分类
    secondaryDirectory: undefined, //二级目录
    practiseFunction: undefined,  //刷题功能区
    numberCompletedQuestions: 0,  //已完成题目数
    masteryDegree: 0,  //掌握程度
    totalNumber: 0     //题集总数量
  }
}

// 对埋点value进行有值判断
export let getParam = (data) => {
  return data !== '' ? data : undefined
}


// 存储题库 刷题功能区	STRING	章节练习、速记刷题、历年真题、精选案例、背诵卡片、智能组卷、分科真题、章节练习（历史）、试卷练习（历史）、精选案例（历史）、专项练习（历史）
export let setLocal = (data) => {
  try{
    localStorage.setItem('localData',JSON.stringify({
      position: data
    }))
  }catch(e){
    console.log('缓存异常');
  }
}

// 存储刷题入口    enum：列表页开始刷题、列表页继续作答（继续练习）、报告页继续练习、报告页再做一次（含再来x道）、
export const setPractiseEntry = (value) => {
  try{
    localStorage.setItem('practiseEntry',value)
  }catch(e) {
    console.log('存储刷题入口异常',e)
  }
}

// 首页模块点击 埋点
export const sendHomePageBuryingPoint = ({ title }) => {
    System.sensorsLog('homePageClick', {
        homePageFeatures: title
    })
}

// 个人中心页模块点击
export const sendMyPageBuryingPoint = ({ title }) => {
  System.sensorsLog('myPageFunctionClick', {
    myPageFeatures: title
  })
}

// 官网导航点击
export const sendWebNavBuryingPoint = ({ title, website }) => {
  // website 取值
  if (!website && window.location.hostname.includes('zhongheschool.com')) {
    if (window.location.pathname.includes('fashuo')){
      website = '众合法硕'
    }
    if (window.location.pathname.includes('fakao')){
      website = '众合法考'
    }
  }
  if (!website && window.location.hostname.includes('zhuma')) {
    website= '竹马官网'
  }
  System.sensorsLog('webFeaturesClick', {
    webFeatures: title,  //官网导航 enum:首页、学习效果测试、题库、公开课、商城、积分商城、App下载、关于我们、我的题库、我的订单、个人中心、教学计划、关于众合、众合招聘、合作单位、错题本、收藏题目、我的笔记、做题历史、我的订单、我的课程
    website //  官网站点  enum:众合法考、众合法硕、众合在线APP、竹马APP、国桓官网
  })
}

// 金刚区埋点
export const sendDiamondBuryingPoint = (pointName,{ fakaoQuestionType , diamond }) => {
  System.sensorsLog( pointName , {
    fakaoQuestionType ,
    diamond
  })
}

export const sendHistoryChapterBuryingPoint = (pointName,{ fakaoQuestionType  }) => {
  System.sensorsLog( pointName , {
    fakaoQuestionType 
  })
}

// 获取公用埋点数据接口
export const get_bury_data = '/api/question/bank/getQuestionInfoForSensor'

// 获取埋点数据 - 公用数据和私有数据 
export const fetch_bury_data = async (params) => {
  const {data} = await System.user.mockGet(get_bury_data, params)
  shuaTiburyPoints({
    fakaoQuestionType: getParam(data?.questionType),      //刷题题型
    primaryCatagory: getParam(data?.primaryCatagory),  //一级分类
    firstDirectory: getParam(data?.firstDirectory),   //一级目录
    secondaryCatagory: getParam(data?.secondaryCatagory), //二级分类
    secondaryDirectory: getParam(data?.secondaryDirectory), //二级目录
    practiseFunction: JSON.parse(localStorage.getItem('localData'))?JSON.parse(localStorage.getItem('localData')).position:undefined,
    numberCompletedQuestions: data?.numberCompletedQuestions,  //已完成题目数
    masteryDegree: data?.masteryDegree,  //掌握程度
    totalNumber: data?.totalNumber,    //题集总数量
    practiseEntry: localStorage.getItem('practiseEntry') ? localStorage.getItem('practiseEntry') : undefined, //刷题入口  列表页开始刷题、列表页继续作答（继续练习）、报告页继续练习、报告页再做一次（含再来x道）、
  })
}
// 章节练习  /w/shuati/catalog  https://test.zhumavip.com/java-api/api/question/answer/record/answerV2
// 速记刷题  /w/sujiReciteInfo  https://test.zhumavip.com/java-api/api/question/answer/record/answer
// 历年真题  /w/overYearsOptions  https://test.zhumavip.com/java-api/api/question/answer/record/answerV2
// 精选案例  /w/shuati/catalog  https://test.zhumavip.com/java-api/api/question/answer/record/answerV2
// 背诵卡片  /w/beisongrecite   https://test.zhumavip.com/java-api/api/question/answer/record/answer
// 智能组卷  /w/setUpIntelligence  https://test.zhumavip.com/java-api/api/question/answer/record/answerV2
// 分科真题  /w/shuati/catalog 和章节练习路由一样 https://test.zhumavip.com/java-api/api/question/answer/record/answerV2
// 章节练习（历史） 题库主页-右下角 /w/questionBank、做题历史页面(多入口，不能依赖于路由，需要依赖于tab) /w/my/history
// 试卷练习（历史） 题库主页-右下角 /w/questionBank、做题历史页面(多入口，不能依赖于路由，需要依赖于tab) /w/my/history
// 精选案例（历史） 主观题 题库主页-右下角、做题历史页面
// 分科真题 (历史)  主观题  题库主页-右下角、做题历史页面




// 题库 - 开始刷题 埋点
// 如何认定为开始刷题？ 请求了题集即为开始刷题
export const practiseStartBuryingPoint = () => {
  System.sensorsLog('practiseStart',buryPoints)
    // fakaoQuestionType: buryPoints.fakaoQuestionType ,	//法考刷题题型	STRING	主观题、客观题、主观+客观
    // primaryCatagory: buryPoints.primaryCatagory ,	//一级分类	STRING	
    // firstDirectory: buryPoints.firstDirectory ,	//一级目录	STRING	
    // secondaryCatagory: buryPoints.secondaryCatagory ,	//二级分类	STRING	
    // secondaryDirectory: buryPoints.secondaryDirectory ,	//二级目录	STRING	
    // practiseFunction: buryPoints.practiseFunction ,	//刷题功能区	STRING	章节练习、速记刷题、历年真题、精选案例、背诵卡片、智能组卷、分科真题、章节练习（历史）、试卷练习（历史）、精选案例（历史）、专项练习（历史）
    // numberCompletedQuestions: buryPoints.numberCompletedQuestions ,	//已完成题目数	NUMBER	
    // masteryDegree: buryPoints.masteryDegree ,	//掌握程度	NUMBER	1~5
    // totalNumber: buryPoints.totalNumber ,	//题集总题目数量	NUMBER	
    // practiseEntry: buryPoints.practiseEntry ,	//刷题入口	STRING	列表页开始刷题、列表页继续作答（继续练习）、报告页继续练习、报告页再做一次（含再来x道）、
  
}

// 题库 - 退出刷题 埋点
export const quitPractiseBuryingPoint = () => {
  System.sensorsLog('quitPractise',buryPoints)
  // questionsAnswered	答题数量	NUMBER
}

export const getBusinessTypeId = () => {
  if (System.isZhumavip()) {
    return System.user.businessTypeInfo.businessTypeId
  } else {
    // 众合
    if (System.isFakao()) {
      return '104'
    } else {
      return '90'
    }
  }
}

// 用户每日首次进入  后端埋，只需要调接口就行
export const getUserFirstEnterHome = async ()=>{
  await System.user.get(System.api.user_first_enter_home,{
      /**
       * 业务类型ID 104=法考；90=法硕
       */
      businessTypeId: getBusinessTypeId(),
      /**
       * zhumaWeb=竹马官网；schoolWeb=众合官网 [channel枚举]
       */
      channel: System.isZhumavip() ? 'zhumaWeb' : 'schoolWeb',
      /**
       * 客户端类型 app=移动端；web=官网；wap=H5 [客户端类型（app,web,wap）]
       */
      clientType: 'web',
      /**
       * 用户ID  
       */
      userId: System.user.id || ''
  }).then(res=>{
      if (res.status === 200) {
          return res.data
      }else {
          return res.msg
      }
  })
}

